<template>
  <div class="aside row row-30 row-md-50 justify-content-md-between">    
    <div class="aside-item col-sm-6 col-md-5 col-lg-12">
        <!-- RD Search Form-->
        <div class="rd-search form-search mb-5">
        <div class="form-wrap">
            <label class="form-label" for="search-form">Search in shop...</label>
            <input v-model="store.filters.search" class="form-input" id="search-form" type="text" name="s" autocomplete="off" />
            <button class="button-search fl-bigmug-line-search74"></button>
        </div>
        </div>
        
        <h6 class="aside-title">Categories</h6>
        <ul class="list-shop-filter">
        <li v-for="category in commonStore.categories" :key="category.id">
            <label class="checkbox-inline">
            <input name="input-group-radio" :value="`checkbox-${category.id}`" type="checkbox" :checked="store.filters.category_id.includes(category.id)" @change="store.setFilterCategory(category.id)">{{ category.name }}
            </label><span class="list-shop-filter-number">({{ category.total_products }})</span>
        </li>        
        </ul>

        <template v-for="attribute in commonStore.attributes" :key="attribute.id">
            <h6 class="aside-title mt-4">{{ attribute.name }}</h6>
            <ul class="list-shop-filter">
                <li v-for="option in attribute.attribute_values" :key="option.id">
                    <label class="checkbox-inline">
                    <input name="input-group-radio" :value="`checkbox-${option.id}`" type="checkbox" :checked="store.filters.attributes[attribute.id]?.includes(option.id)" @change="store.setFilterAttribute(attribute.id, option.id)">{{ option.value }}
                    </label><span class="list-shop-filter-number">({{ option.total_products }})</span>
                </li>        
            </ul>
        </template>        
    </div>
    <!-- <div class="aside-item col-sm-6 col-lg-12">
        <h6 class="aside-title">Popular products</h6>
        <div class="row row-20 gutters-10">
            <div class="col-4 col-sm-6 col-md-12">
                <article class="product-minimal">
                <div class="unit unit-spacing-sm flex-column flex-md-row align-items-center">
                    <div class="unit-left"><a class="product-minimal-figure" href="#"><img src="/assets/images/product-mini-1-106x104.png" alt="" width="106" height="104"/></a></div>
                    <div class="unit-body">
                    <p class="product-minimal-title"><a href="#">Chocolate Pudding</a></p>
                    <p class="product-minimal-price">$25.00</p>
                    </div>
                </div>
                </article>
            </div>        
        </div>
    </div> -->
  </div>
</template>
<script setup>
import { useCommonStore } from "@/stores/commonStore";
import { useProductStore } from "@/stores/productStore";
import { watch } from "vue";
const commonStore = useCommonStore();
const store = useProductStore();

watch(
  () => store.filters.search,
  () => {
    const debounce = (fn, delay) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), delay);
      };
    };
    const debouncedSetSearch = debounce(() => store.setSearch(store.filters.search), 1000);
    debouncedSetSearch();
  },
  { deep: true }
);
</script>